export const removeGroups = (groupIDs, announcement) => {
	const groupsToRemove = groupIDs.map(group => group.id);
	const newAnnouncement = { ...announcement };
	newAnnouncement.groups = announcement.groups.filter(group => !groupsToRemove.includes(group.id));
	return newAnnouncement;
};

export const addGroups = (groupIDs, announcement) => {
	const newAnnouncement = { ...announcement };
	newAnnouncement.groups = [...announcement.groups, ...groupIDs];
	return newAnnouncement;
};
